var normalizeComponent = require("!../../node_modules/_vue-loader@13.0.2@vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../node_modules/_vue-loader@13.0.2@vue-loader/lib/selector?type=script&index=0!./WxIdGuide.vue"
/* template */
import __vue_template__ from "!!../../node_modules/_vue-loader@13.0.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1544656e\",\"hasScoped\":false}!../../node_modules/_vue-loader@13.0.2@vue-loader/lib/selector?type=template&index=0!./WxIdGuide.vue"
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WxIdGuide.vue
// module id = 198
// module chunks = 0